import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '../Wrappers/Wrappers';
import LoadingAnimation from '../LoadingAnimation';

const useStyles = makeStyles({
  textButton: {
    textTransform: 'none',
    fontWeight: 400,
  },
});

function formatTime (seconds) {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
}

function ResendButton ({ label, onClick, isResending, disabled, timeRemaining, className }) {
  const classes = useStyles();

  if (isResending) {
    return (<LoadingAnimation />);
  }

  const buttonLabel =
    timeRemaining != null ? `${label} (${formatTime(timeRemaining)})` : label;

  return (
    <Button
      onClick={onClick}
      size="large"
      color="primary"
      className={className ?? classes.textButton}
      disabled={disabled || (timeRemaining != null && timeRemaining > 0)}
    >
      {buttonLabel}
    </Button>
  );
}

ResendButton.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  isResending: PropTypes.bool,
  disabled: PropTypes.bool,
  timeRemaining: PropTypes.number,
  className: PropTypes.string,
};

ResendButton.defaultProps = {
  label: 'Resend OTP',
  onClick: () => {},
  isResending: false,
  disabled: false,
  timeRemaining: undefined,
  className: undefined,
};

export default ResendButton;
